
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(51|88)4$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
